import { createInstance } from './axios.api'
import {
  ContactFormRequest,
  Properties
} from '@/types/contact-form-page.types'

export const submitContactForm = async (contactFormRequest: ContactFormRequest, token: string): Promise<void> => {
  const axios = createInstance(process.env.VUE_APP_CIAM_URL, undefined, true)
  const formData = new FormData()

  formData.append(Properties.CaseReason, contactFormRequest.caseReason)
  formData.append(Properties.Description, contactFormRequest.description)
  formData.append(Properties.FullName, contactFormRequest.fullName)
  formData.append(Properties.StreetAddress, contactFormRequest.streetAddress)
  formData.append(Properties.ZipCode, contactFormRequest.zipCode)
  formData.append(Properties.City, contactFormRequest.city)
  formData.append(Properties.PhoneNumber, contactFormRequest.phoneNumber)
  formData.append(Properties.EmailAddress, contactFormRequest.emailAddress)
  formData.append(Properties.PersonalIdentityNumber, contactFormRequest.personalIdentityNumber)
  formData.append(Properties.PreferredContactForm, contactFormRequest.preferredContactForm)
  formData.append(Properties.Token, token)

  const attachments = contactFormRequest.attachments

  attachments.forEach( attachment => {
    formData.append('attachments', attachment)
  })

  await axios.post('/create', formData)
}
